import { Component } from '@angular/core';

@Component({
  selector: 'app-footer',
  standalone: true,
  templateUrl: './footer.html',
  styleUrl: './footer.scss',
})
export class FooterComponent {
  currentYear = new Date().getFullYear();

  navLinks = [
    { label: 'Talleres', id: 'talleres' },
    { label: 'Eventos privados', id: 'colaboraciones' },
    { label: 'Sobre Aruma', id: 'about' },
    { label: 'Dudas', id: 'faqs' },
    { label: 'Contacto', id: 'contacto' },
  ];

  socialLinks = [
    { label: 'Instagram', href: 'https://instagram.com', icon: 'instagram' },
    { label: 'TikTok', href: 'https://tiktok.com', icon: 'tiktok' },
  ];

  scrollTo(id: string) {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  }
}
